// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"Layout_footer-wrapper__+iSl4","sp-menu":"Layout_sp-menu__Ka1qg","sp-menu-active":"Layout_sp-menu-active__JYIQ2"};